import { BetFilterActionTypes } from '../types/actions/betFilter';

export const askRoute = ({ route, betFilterId }: { route: string; betFilterId?: number }) => ({
  type: BetFilterActionTypes.ASK_BET_FILTER_ROUTE,
  payload: {
    route,
    betFilterId,
  },
});

export const set = (id: number) => ({
  type: BetFilterActionTypes.SET_BET_FILTER,
  payload: {
    id,
  },
});

export const setPending = (isPending: boolean) => ({
  type: BetFilterActionTypes.SET_BET_FILTER_PENDING,
  payload: {
    isPending,
  },
});

export const receive = (id: number) => ({
  type: BetFilterActionTypes.RECEIVE_BET_FILTER,
  payload: {
    id,
  },
});
